const deps = ['bench.main-app', require('angular-ui-router'), require('ui/bk/reviewTool').name];

module.exports = angular
  .module('bench.app.mainapp.reviewtool', deps)
  .config(($stateProvider, MainAppConfig) => {
    const stateName = 'bench.reviewtool';
    const path = MainAppConfig.routes[stateName];

    return $stateProvider.state(stateName, {
      url: `${path}?startDate&endDate&reviewing&restoreLastChecks`,
      params: {
        startDate: null,
        endDate: null,
        reviewing: null,
        restoreLastChecks: null,
      },
      views: {
        '': {
          controller($state, $stateParams) {
            this.clientId = $stateParams.clientId;
            this.startDate = $stateParams.startDate;
            this.endDate = $stateParams.endDate;
            this.reviewing = $stateParams.reviewing === 'true';
            this.restoreLastChecks = $stateParams.restoreLastChecks === 'true';
            this.onReviewingChange = (reviewing, restoreLastChecks, startDate, endDate) => {
              if (reviewing) {
                $state.go('bench.reviewtool', {
                  reviewing,
                  restoreLastChecks,
                  startDate,
                  endDate,
                });
              } else {
                $state.go('bench.reviewtool', {
                  reviewing: null,
                  restoreLastChecks: null,
                  startDate: null,
                  endDate: null,
                });
              }
            };
            return this;
          },
          controllerAs: 'vm',
          template: `
              <review-tool
                clientId="vm.clientId"
                startDate="vm.startDate"
                endDate="vm.endDate"
                reviewing="vm.reviewing"
                onReviewingChange="vm.onReviewingChange"
                restoreLastChecks="vm.restoreLastChecks"
              >
              </review-tool>
            `,
        },
      },
    });
  });
